module.exports = __webpack_public_path__ + "img/voting-down-disabled.c9b8fa0b.svg";